export const currentFolderScopeLabel = "$RHJtb";
export const recursiveFolderScopeLabel = "s1_i0d";
export const allMailboxesScopeLabel = "nUbPfd";
export const allPstFilesScopeLabel = "t_wumc";
export default {currentFolderScopeLabel,recursiveFolderScopeLabel,allMailboxesScopeLabel,allPstFilesScopeLabel};